import Vue from 'vue';
import VueRouter from 'vue-router';
//import { nextTick } from 'vue/types/umd';
//import { vueFetch } from '../plugins/fetch';
import routes from './routes';
//import { app } from '../main';
//import { parseISO, add } from 'date-fns';

Vue.use(VueRouter);

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
});

router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.name === 'Inicio')) {
		router.push({ path: '/emendas' });
	} else {
		next();
	}
});

//ref: https://www.digitalocean.com/community/tutorials/how-to-set-up-vue-js-authentication-and-route-handling-using-vue-router
// router.beforeEach(async (to, from, next) => {
// 	let usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
// 	if (!usuarioLogado || new Date() > parseISO(usuarioLogado.expirationDate)) {
// 		usuarioLogado = await vueFetch.get('permisys');
// 		if (usuarioLogado) {
// 			usuarioLogado.expirationDate = add(new Date(), { minutes: 5 });
// 			localStorage.setItem('usuarioLogado', JSON.stringify(usuarioLogado));
// 		} else {
// 			localStorage.removeItem('usuarioLogado', JSON.stringify(usuarioLogado));
// 		}
// 		if (app) {
// 			app.usuarioLogado = usuarioLogado;
// 		}
// 	}
// 	if (to.matched.some(record => record.name === 'Inicio')) {
// 		router.push({ path: '/Emendas' });
// 	} else if (to.matched.some(record => !record.meta.anonymous)) {
// 		if (!usuarioLogado) {
// 			router.push({ path: '/login', query: { nextUrl: to.fullPath } });
// 		}
// 		if (
// 			to.matched.some(record => !!record.meta.functions) &&
// 			usuarioLogado &&
// 			usuarioLogado.funcoes
// 		) {
// 			let hasFunctions = to.matched.some(record =>
// 				record.meta.functions.every(fn => usuarioLogado.funcoes.includes(fn))
// 			);
// 			if (hasFunctions) {
// 				next();
// 			} else {
// 				router.push({ path: '/404', query: { triedUrl: to.fullPath } });
// 			}
// 		} else {
// 			next();
// 		}
// 	} else {
// 		next();
// 	}
// });

export default router;
